import { UNLICENSED } from '@jira/platform__application-editions/src/edition.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

export const useShowCustomerServiceAnalytics = (): boolean => {
	const isAdmin = useIsAdmin();
	const { customerService } = useAppEditions();

	if (customerService === UNLICENSED) {
		return false;
	}

	return isAdmin;
};
